import axios from "axios";
import { MESSAGES_PORTAL_URL } from "../../API/Api";

const GetAllLastChats = async (user_id) => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };
    let response = await axios({
        method: "POST",
        baseURL: `${MESSAGES_PORTAL_URL}/chat/get_users_with_last_chat`,
        headers: headers,
        data: {
            auth_user: user_id,
            site_auth_user: "crm",
        },
    });
    return response.data;
};

const SendMessageMethod = async (data) => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };
    let response = await axios({
        method: "POST",
        baseURL: `${MESSAGES_PORTAL_URL}/chat/message/store`,
        headers: headers,
        data: data,
    });
    return response.data;
};
const GetAllMessages = async (data) => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };
    let response = await axios({
        method: "POST",
        baseURL: `${MESSAGES_PORTAL_URL}/chat/message`,
        headers: headers,
        data: { ...data, site_auth_user: "crm" },
    });
    return response.data;
};


const GetTheNewMessages = async (data) => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };
    let response = await axios({
        method: "POST",
        baseURL: `${MESSAGES_PORTAL_URL}/chat/get_last_chat`,
        headers: headers,
        data: { ...data, site_auth_user: "crm" },
    });
    return response.data;
};

const GetAllDepartments = async () => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };
    let response = await axios({
        method: "GET",
        baseURL: `${MESSAGES_PORTAL_URL}/role`,
        headers: headers,
    });
    return response.data;
};

const GetUserByRole = async (data) => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };

    let response = await axios({
        method: "POST",
        baseURL: `${MESSAGES_PORTAL_URL}/role/get_users_by_role`,
        headers: headers,
        data: { ...data },
    });
    return response.data;
};

const MessagesService = {
    GetAllLastChats,
    GetAllMessages,
    GetTheNewMessages,
    GetAllDepartments,
    GetUserByRole,
    SendMessageMethod
};

export default MessagesService;
